import Tooltip from '@mui/material/Tooltip';
import { TableColumn } from '@components/Table';
import { ActivityLog } from './types';
import {
  getActivityTypeIcon,
  getActivityTypeLabel,
  getInitials,
  getStatusTone,
  getInitiatorRole,
  activityTypeOptions,
} from './helpers';
import { DateCell, DetailsCell, InitiatorCell, MiniAvatar, StatusPill, TypeCell, TypeIcon } from './styles';
import { getEventDayAndTime } from '@utils/timeHelpers';

export const columns: TableColumn<ActivityLog>[] = [
  {
    key: 'date',
    title: 'Date',
    width: 110,
    sortable: true,
    defaultSortDirection: 'DESC',
    // filter: {
    //   type: 'date-range',
    //   presets: [
    //     { value: 'all', label: 'All time' },
    //     { value: '7', label: 'Last 7 days' },
    //     { value: '30', label: 'Last 30 days' },
    //     { value: '90', label: 'Last 90 days' },
    //   ],
    // },
    render: (row) => {
      if (!row.startDate) return null;
      const date = getEventDayAndTime(row.startDate);
      return (
        <DateCell>
          {date.day}
          <small>{date.time}</small>
        </DateCell>
      );
    },
  },
  {
    key: 'type',
    title: 'Activity type',
    width: 200,
    filter: {
      type: 'multi-select',
      options: activityTypeOptions,
      searchable: true,
    },
    render: (row) => {
      const displayType = row.actionType || row.type;
      const Icon = getActivityTypeIcon(displayType);
      return (
        <TypeCell>
          <TypeIcon>
            <Icon />
          </TypeIcon>
          <span>{getActivityTypeLabel(displayType)}</span>
        </TypeCell>
      );
    },
  },
  {
    key: 'details',
    title: 'Details',
    width: '30%',
    render: (row) => row.details ? (
      <Tooltip title={row.details} placement="bottom" arrow>
        <DetailsCell>{row.details}</DetailsCell>
      </Tooltip>
    ) : null,
  },
  {
    key: 'status',
    title: 'Status',
    width: 145,
    render: (row) => {
      const status = row.status;
      if (!status) return null;
      return <StatusPill tone={getStatusTone(status)}>{status}</StatusPill>;
    },
  },
  {
    key: 'initiator',
    title: 'Initiator',
    width: 160,
    render: (row) =>
      row.initiator && (
        <InitiatorCell>
          <Tooltip title={row.initiator.fullName} placement="bottom" arrow>
            <MiniAvatar>{getInitials(row.initiator.fullName)}</MiniAvatar>
          </Tooltip>
          <small>{getInitiatorRole(row.initiator.roles || [])}</small>
        </InitiatorCell>
      ),
  },
];
